import Vue from 'vue'
import Component from 'vue-class-component'
import moduleStore from '../../store/videoEditor';
import PageState from '../../store/state';
import { Prop } from 'vue-property-decorator';

@Component({
  props: {
    list: {
      type: Array,
      default: () => []
    },
    activeFont: {
      type: Object,
      default: null
    }
  }
})
@moduleStore.initVuex({
  mutationNames: moduleStore.mutationNames,
  actionNames: moduleStore.actionNames
})
export default class FontContent extends Vue {
  @Prop({default: ''})
  source: string
  state = new PageState();
  mounted(moduleData: IinjectDatas) {
    this.state = <PageState>moduleData.state;
  }
  get contentHeight() {
    if (this.source === 'text_template') {
      return '352px'
    }
    return this.state.styleContentHeight || '426px'
  }
  selectFont(font, index) {
    this.$emit('select-font', font)
  }
  downloadFont(font) {
    this.$emit('download-font', font)
  }
}